<template>
  <div class="card-minimal">
    <card-minimal-title :title="title" :titleLink="titleLink" :titleLinkText="titleLinkText" :tooltip="tooltip" :tooltipClass="tooltipClass" />
    <section class="card-content">
      <div class="card-subtitle" v-if="subtitle || subtitleIcon">
        <i :class="`icon-${subtitleIcon}`" v-if="subtitleIcon" />
        <div class="subtitle" v-if="subtitle">
          {{ subtitle }}
          <slot name="subtitle-slot" />
          <div :class="`tooltip ${tooltipClass} ml-a`" v-if="tooltip">
            <i class="mdi mdi-help-circle" />
            <div class="tooltiptext">{{ tooltip }}</div>
          </div>
        </div>
      </div>
      <div class="card-header" v-if="!!$slots.header">
        <slot name="header" />
      </div>
      <slot />
      <div class="card-button border-light-tyop" v-if="!!$slots.footerButton">
        <slot name="footerButton" />
      </div>
    </section>
    <footer v-if="!!$slots.footer">
      <slot name="footer" />
    </footer>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    subtitleIcon: {
      type: String,
      default: '',
    },
    tooltip: {
      type: String,
      default: null,
    },
    tooltipClass: {
      type: String,
      default: '',
    },
    titleLink: {
      type: String,
      default: '',
    },
    titleLinkText: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss">
.card-content-title {
  font-size: 15px;
  line-height: 20px;
  margin-bottom: 6px;
  font-weight: 500;
  color: #848893;

  strong {
    font-weight: 500;
  }

  span {
    color: rgb(73, 73, 73);
    font-size: .9rem;
    font-style: italic;
    padding-left: 7px;

    &.link {
      font-style: normal;
      font-size: .8rem;
      color: #0060FF;
      cursor: pointer;
    }
  }

  &.black {
    color: black;

    span {
      color: #868B97;
    }
  }
}
</style>

<style lang="scss">
.card-minimal {
  &.flex {
    display: flex;
    min-width: 0;

    &.flex-col {
      flex-direction: column;
    }

    .card-content {
      display: flex;
      flex-direction: column;
      flex: 1;
    }
  }
  &.error {
    .card-content {
      background-color: rgba(#D0021B, .2);
    }
  }
  &.white {
    .card-content {
      background-color: white;
      overflow: hidden;
    }
  }

  &.no-bg {
    .card-content {
      background-color: unset;
      box-shadow: unset;
      overflow: hidden;
    }
  }

  &.no-shadow {
    .card-content {
      box-shadow: unset;
    }
  }

  &.o-h {
    .card-content {
      overflow: hidden;
    }
  }

  .card-footer {
    align-items: center;
    display: flex;
    font-size: 1.2rem;
    padding: 0 10px;
    margin-top: 10px;
  }

  .card-content {
    background-color: white;
    border-radius: 10px;
    // box-shadow: 0 6px 12px 0 rgba(0,0,0,0.04), 0 2px 4px 0 rgba(0,0,0,0.04);
    box-shadow: 0 2px 8px 0 rgba(52,64,76,0.16), 0 0 0 1px rgba(170,182,195,0.50);

    .card-subtitle {
      align-items: center;
      display: flex;
      font-weight: 500;
      font-size: 13px;
      padding: 15px 20px 10px;

      .subtitle {
        color: #848893;
        display: flex;
        align-items: center;
        width: 100%;
      }

      & > i {
        margin-right: 7px;
        font-size: 20px;
      }

      .tooltip {
        i {
          color: var(--color-cta-blue);
          font-size: 16px;
          margin-right: -6px;
        }
      }

      @media (min-width: 768px) {
        font-size: 14px;

        i {
          font-size: 24px;
        }
      }
    }
  }

  &.blue-subtitle {
    .card-content {
      .card-subtitle {
        color: #0060FF;
      }
    }
  }

  &.gray-subtitle {
    .card-content {
      .card-subtitle {
        color: #868B97;
      }
    }
  }

  .card-header {
    background-color: white;
    border-radius: 10px 10px 0 0;
    border-bottom: 1px solid #E7E9EC;

    h2 {
      font-size: 16px;
      line-height: 1.5;
    }
  }

  .card-button {
    &.not-rounded-bottom {
      border-radius: 10px 10px 0 0;
    }
    &.not-rounded-top {
      border-radius: 0 0 10px 10px;
    }
    & > div {
      background-color: white;
      border-radius: 0 0 10px 10px;
      font-size: 1rem;
      transition: background-color .3s;

      &.all-round {
        border-radius: 5px;
      }

      &.rounded-bottom {
        border-radius: 0 0 10px 10px;
      }

      &:not(.no-color) {
        color: #0360FF;
      }

      &:hover:not(.no-hover) {
        cursor: pointer;
        background-color: #EFF5FF;
      }

      i {
        font-size: 1.5rem;
        margin-right: .5rem;
      }
    }
  }

  &.sticky-footer {
    .card-button {
      position: sticky;
      bottom: 0;
    }
  }
}
</style>
